import DatePicker from 'react-date-picker';
import styled from 'styled-components';

export const TableBottomRow = styled.div.attrs({
  className: 'row col-12 mx-0 px-4'
})`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const TableTopRow = styled.div.attrs({
  className: 'row col-12 mx-0 px-0'
})`
  height: 80px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const TableMainWrapper = styled.div.attrs({
  className: 'col-12 p-3'
})`
  font-size: 12px;
`

export const PageWrapper = styled.div`
  overflow-y: scroll;
`

export const LeftSection = styled.span`
  height: 36px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const RightSection = styled.span`
  height: 36px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const SizeWrapper = styled.span`
  height: 36px;
  flex: 0.5;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const AltWrapper = styled.span`
  height: 36px;
  flex: 0.5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const SearchWrapper = styled.span`
  height: 36px;
  flex: ${({isInline}) => isInline ? 1 : 0.5};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`

export const AvaWrapper = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.mocaPurple};
  object-fit: cover;
`

export const StyledSpan = styled.span.attrs({
  className: 'react-bootstrap-table-pagination-total'
})`
  height: 34px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  color: ${({ theme }) => theme.blackAbs};
`

export const NotifTitleSpan = styled.span`
  position: relative;
`

export const NotifUnreadDot = styled.div`
  background-color: ${({theme}) => theme.unreadRed};
  width: 10px;
  height: 10px;
  border-radius: 100%;
  position: absolute;
  top: 0px;
  left: -30px;
`

export const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const ListBullet = styled.li`
  padding-left: .7em;
  text-indent: -.5em;

  &:before {
    content: "●";
    color: ${({ theme }) => theme.mocaOrange};
    display: inline-block;
    width: .6em;
    font-size: 120%;
  }
`
export const Chip = styled.div`
  background: ${({ background }) => background ? background : 'transparent'};
  border-radius: 4px;
  display: ${({ shown }) => shown ? 'inline-block' : 'none'};
  color: ${({ color }) => color};
  padding: 2px 6px;
`

export const StatusDotWrapper = styled.div`
  align-items: center;
  display: flex;
  font-style: italic;
`

export const StatusDot = styled.div`
  background: ${({ background }) => background};
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  height: 6px;
  width: 6px;
`

export const StyledDatePicker = styled(DatePicker)`
  .react-date-picker__wrapper {
    border-radius: 6px !important;
    font-size: 14px !important;
    height: 34px !important;
    border: 1px solid ${({ theme }) => theme.mocaGrey};
    background: ${({ theme }) => theme.white};
  }
  .react-date-picker__inputGroup {
    padding-left: 12px;
  }
`
